import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { PaymentIcons } from '~/components/Icons'
import { Sections } from '~/components/sections'
import { DynamicPortal } from '~/components/utils'
import { ProductPage } from '~/pages/ProductPage'
import '~/styles/layout/theme.less'
import { Header } from './Header/Header'

const App: React.FC = () => (
	<>
		<Header />
		<BrowserRouter>
			<Sections />
			<DynamicPortal selector=".auk-product">
				<ProductPage />
			</DynamicPortal>
			<DynamicPortal selector=".payment-icons-custom">
				<PaymentIcons size="small" className="justify-end" />
			</DynamicPortal>
		</BrowserRouter>
	</>
)

export default App
